/**
 * Lake Charles Champion Application Page
 *
 * Simple wrapper that imports the parameterized ChampionApplicationForm from city-landing-core
 * and passes Lake Charles-specific configuration.
 */

import React from 'react';
import { ChampionApplicationForm } from '@core';
import { submitChampionApplication } from '../services/championApplicationService';
import lakeCharlesConfig from '../city.config';

export function LakeCharlesChampionApplicationPage() {
  return (
    <div>
      <ChampionApplicationForm
        cityName={lakeCharlesConfig.identity.cityName}
        stateName={lakeCharlesConfig.identity.stateName}
        contactEmail="" /* "champions@toolboxlogic.com" */
        heroImage="/media_shared/champion-hero.png"
        enableValidation={false}
        onSubmit={async (data) => {
          const res = await submitChampionApplication(data);
          return { success: res.success, error: res.error, submissionId: res.data?.id };
        }}
      />
    </div>
  );
}
